/**
 * PublicQueuePage.jsx
 *
 * Live queue display for patients.
 * Route: /public/queue/:clinicId
 *
 * STATUS: Coming Soon — full implementation ready but gated.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';
import { ROUTES } from '../constants/routes';

export default function PublicQueuePage() {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const bg = isDark ? '#0f0f11' : '#f5f5f7';
  const textPrimary = isDark ? '#f5f5f7' : '#111827';
  const textSecondary = isDark ? '#9ca3af' : '#6b7280';
  const cardBg = isDark ? 'rgba(255,255,255,0.03)' : '#fff';
  const border = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';

  return (
    <div style={{
      minHeight: '100vh',
      background: bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '420px',
        padding: '3rem 2rem',
        borderRadius: '1.25rem',
        background: cardBg,
        border: `1px solid ${border}`,
        boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.3)' : '0 8px 32px rgba(0,0,0,0.06)',
      }}>
        <span style={{ fontSize: '3.5rem', display: 'block', marginBottom: '1rem' }}>📺</span>
        <h1 style={{
          margin: '0 0 0.5rem',
          fontSize: '1.5rem',
          fontWeight: 700,
          color: textPrimary,
        }}>
          Public Queue Display
        </h1>
        <p style={{
          margin: '0 0 0.25rem',
          fontSize: '1rem',
          fontWeight: 600,
          background: 'linear-gradient(135deg, #0f766e, #3b82f6)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>
          Coming Soon
        </p>
        <p style={{
          margin: '0 0 1.5rem',
          fontSize: '0.8125rem',
          color: textSecondary,
          lineHeight: 1.5,
        }}>
          Live queue status on TV screens &amp; kiosks for your patients.
          Real-time updates with SSE streaming.
        </p>
        <button
          onClick={() => navigate(ROUTES.ORG)}
          style={{
            padding: '0.5rem 1.25rem',
            borderRadius: '0.5rem',
            border: 'none',
            background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)',
            color: '#fff',
            fontSize: '0.8125rem',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
}
